import { useTranslation } from 'react-i18next';

import { SHIPPO_DE_ADDRESS, SHIPPO_US_ADDRESS } from '~/constants/shippo-addresses';

interface OwnProps {
  isGerman: boolean;
}

export const ShippoInvoiceAddress = (props: OwnProps) => {
  const { t } = useTranslation('settings');
  const { isGerman } = props;
  const shippoAddress = isGerman ? SHIPPO_DE_ADDRESS : SHIPPO_US_ADDRESS;

  return (
    <>
      <strong>{shippoAddress.company}</strong>
      <br />
      {shippoAddress.street1}
      <br />
      {shippoAddress.street2 && (
        <>
          {shippoAddress.street2}
          <br />
        </>
      )}
      {isGerman ? (
        <>
          {shippoAddress.zip} {shippoAddress.city}
          <br />
          {shippoAddress.country}
          <br />
          <i>{t('account.billing.invoices.download.vatDisclaimer')}</i>
        </>
      ) : (
        `${shippoAddress.city}, ${shippoAddress.state}, ${shippoAddress.zip}`
      )}
    </>
  );
};
